module.exports = __webpack_public_path__ + "static/img/7.6c5ea04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/7.jpg
// module id = Ud7V
// module chunks = 1